"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineEnquiryBookingStatus = exports.OfferBookingStatus = exports.PendingBookingStatus = exports.WaitlistBookingStatus = exports.CanceledBookingStatus = exports.FixedBookingStatus = exports.OptionBookingStatus = void 0;
exports.OptionBookingStatus = 'OPT';
exports.FixedBookingStatus = 'BKD';
exports.CanceledBookingStatus = 'CXL';
exports.WaitlistBookingStatus = 'WTL';
exports.PendingBookingStatus = 'PDG';
exports.OfferBookingStatus = 'ENQ';
exports.OnlineEnquiryBookingStatus = 'REQ';
//# sourceMappingURL=booking.js.map